import React from "react";
import "./repair.css"
import useSeo from "../../hooks/useSeo";
const Repair = () => {
  // La pantalla todavía no tiene contenido: mientras siga así conviene que no
  // se indexe, porque una página vacía baja la valoración del resto del sitio.
  useSeo({
    titulo: "Reparaciones",
    descripcion: "Reparación de dispositivos Apple en Capital Federal.",
    ruta: "/reparacion",
    noIndex: true
  });

  return <div>Repair</div>;
};

export default Repair;
